import { render, staticRenderFns } from "./QZ06.vue?vue&type=template&id=1948a532&scoped=true"
import script from "./QZ06.vue?vue&type=script&lang=js"
export * from "./QZ06.vue?vue&type=script&lang=js"
import style0 from "./QZ06.vue?vue&type=style&index=0&id=1948a532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948a532",
  null
  
)

export default component.exports